import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { MedicoService } from 'src/app/services/medico.service';
import { EstadoCuenta } from 'src/app/models/estado-cuenta.interface';

@Component({
  selector: 'app-medico-saldo',
  templateUrl: './medico-saldo.component.html',
  styleUrls: ['./medico-saldo.component.scss']
})
export class MedicoSaldoComponent {
  estadoCuenta: EstadoCuenta[] = [];
  constructor(
              private medicoService: MedicoService, 
              private authService: AuthService) {
                
                if(this.authService.isLoggedIn) {
                  const id: number | undefined = this.authService.getUsuario?.medico?.id;
                  if(id) this.obtenerInformacion(id);
              }

              }
   obtenerInformacion(id: number): void {
    this.medicoService.getEstadoCuenta(id)
    .subscribe({
      next:(resp)=>{ this.procesoEstadoCuenta(resp);  console.log(resp) },
      error: (err)=>{ console.log(err)}
    })
   }  
   
   procesoEstadoCuenta(estadocuenta: EstadoCuenta[]){
     for(let i in estadocuenta){
        this.suma(parseInt(i), estadocuenta);
     }
     this.estadoCuenta.push(...estadocuenta);
   }
    suma(i: number, estadocuenta: EstadoCuenta[]): number{
    if( (estadocuenta.length - (i + 1) ) == 0){
      estadocuenta[i].saldo = estadocuenta[i].puntos - estadocuenta[i].canje;
      return  estadocuenta[i].saldo; 
    }else{
      estadocuenta[i].saldo = estadocuenta[i].puntos - estadocuenta[i].canje + this.suma( i + 1, estadocuenta);
      return estadocuenta[i].saldo;
    }
   } 
}
